
window.addEventListener("load", function(e) {
  hide_loading_overlay();
});
